export const noEmptyRule = (i18n: any) => [
  (v: string | any[]) => {
    if (Array.isArray(v)) return v.length > 0 || i18n.t("formValidation.pleaseEnter");
    return !!v || i18n.t("formValidation.pleaseEnter");
  },
];

export const noEmptyRules = (i18n: any) => [
  (v: string | any[]) => {
    if (Array.isArray(v)) return v.length > 0 || i18n.t("formValidation.pleaseEnter");
    if (typeof v === "string") return !!v || i18n.t("formValidation.pleaseEnter");
    return !!v || i18n.t("formValidation.pleaseEnter");
  },
];

export const noSpaceOrEmptyRules = (i18n: any) => [
  (v: string | null | undefined) => {
    if (typeof v === "string" && v.trim()) return true;
    return i18n.t("formValidation.pleaseEnterNoSpace");
  },
];
